<template>
  <div>
    <b-card no-body>
      <b-card-body class="flex flex-col gap-5 border">
        <b-tabs>
          <template #tabs-end>
            <div class="d-flex gap-5 font-lg w-full border-bottom">
              <b-nav-item
                :active="activeRoute === 'information'"
                href="#"
                role="presentation"
                @click="
                  $router.push({
                    name: 'customer_regions_price_list',
                    params: { id: $route.params.id }
                  })
                "
                >{{ $t('General Information') }}
              </b-nav-item>
              <b-nav-item
                :active="activeRoute === 'list'"
                href="#"
                role="presentation"
                @click="
                  $router.push({ name: 'customer_regions_list', params: { id: $route.params.id } })
                "
                >{{ $t('Regionalization Model Structure') }}
              </b-nav-item>
            </div>
          </template>
        </b-tabs>
        <router-view />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { BTabs, BNavItem, BCard, BCardBody } from 'bootstrap-vue';

export default {
  name: 'ProviderRegionContent',
  components: {
    BTabs,
    BNavItem,
    BCard,
    BCardBody
  },
  data() {
    return {
      data: {
        region_model_type: '',
        status: 'LOADING',
        message: ''
      }
    };
  },
  computed: {
    activeRoute() {
      const segments = this.$route.path.split('/');
      return segments[segments.length - 1];
    }
  }
};
</script>
